<template>
  <div class="stepBox">
    <van-steps
      :active="active"
      :active-color="mainColor"
      inactive-color="#666"
    >
      <van-step>
        <template #active-icon>
          <div class="step-icon step-icon--active">
            <van-icon name="success" />
          </div>
        </template>
        <template #inactive-icon>
          <div class="step-icon step-icon--inactive">
            <van-icon name="success" />
          </div>
        </template>
        <template #finish-icon>
          <div class="step-icon step-icon--finish">
            <van-icon name="success" />
          </div>
        </template>
        基本信息
      </van-step>
      <van-step v-if="gconfig.IsHaveQuestion === 'True'">
        <template #active-icon>
          <div class="step-icon step-icon--active">
            <van-icon name="success" />
          </div>
        </template>
        <template #inactive-icon>
          <div class="step-icon step-icon--inactive">
            <van-icon name="success" />
          </div>
        </template>
        <template #finish-icon>
          <div class="step-icon step-icon--finish">
            <van-icon name="success" />
          </div>
        </template>
        问卷调查
      </van-step>
      <van-step>
        <template #active-icon>
          <div class="step-icon step-icon--active">
            <van-icon name="success" />
          </div>
        </template>
        <template #inactive-icon>
          <div class="step-icon step-icon--inactive">
            <van-icon name="success" />
          </div>
        </template>
        <template #finish-icon>
          <div class="step-icon step-icon--finish">
            <van-icon name="success" />
          </div>
        </template>
        登记成功
      </van-step>
    </van-steps>
  </div>
</template>
<script setup>
import { decryptionECB } from '@/utils/utils.js'
import { defineProps, computed } from 'vue'
// import { vanStep, vanSteps } from 'vant'
import { useStore } from 'vuex'
const store = useStore()
const mainColor = computed(() => store.state.mainColor)
// 全局配置
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const gconfig = computed(() => getConfigObj(store.state.gconfig))
// console.log(gconfig.value, '444')

const props = defineProps({
  active: {
    type: Number,
    default: () => 0
  }
})
// console.log(props)
</script>
<style lang="less">
.stepBox {
  padding: 8px 16px 10px;
  background: var(--bg-card, #fff);
  margin-bottom: 8px;
  margin-top: -8px;

  .van-steps {
    background: transparent;
  }

  .van-steps--horizontal {
    padding: 8px 16px 0;
  }

  // 步骤项布局 - 文字在上，图标在下
  .van-step--horizontal {
    flex-direction: column-reverse !important; // 反转顺序：文字在上，图标在下
    padding-bottom: 0;
  }

  // 步骤标题样式 - 在上方，确保不被遮挡
  .van-step__title {
    font-size: 12px;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 18px;
    line-height: 1.4;
    position: relative;
    z-index: 10; // 确保文字在连接线上方
    background: var(--bg-card, #fff); // 背景色遮挡连接线
    padding: 0 4px;
  }

  .van-step--finish .van-step__title {
    color: var(--color-primary, #E60044);
  }

  .van-step--process .van-step__title {
    color: var(--color-primary, #E60044);
    font-weight: 600;
  }

  // 图标容器 - 在下方
  .van-step--horizontal .van-step__circle-container {
    background: transparent;
    padding: 0;
    z-index: 2;
    top: 40px;
  }

  // 自定义步骤图标
  .step-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    transition: all 0.3s ease;

    &--active {
      background: var(--color-primary, #E60044);
      color: #fff;
      box-shadow: 0 2px 6px rgba(230, 0, 68, 0.3);
    }

    &--inactive {
      background: var(--bg-secondary, #F2F3F5);
      color: #666;
    }

    &--finish {
      background: color-mix(in srgb, var(--color-primary, #E60044) 10%, transparent);
      color: var(--color-primary, #E60044);
    }
  }

  // 连接线样式 - 向上提，靠近文字
  .van-step__line {
    height: 1px !important;
    background: #BFBFBF !important;
    top: auto !important;
    bottom: 25px !important;
    z-index: 1 !important;
  }

  .van-step--finish .van-step__line {
    background: var(--color-primary, #E60044) !important;
  }

  // 第一个步骤图标向右挪，对齐文字中心
  .van-step--horizontal:first-child .van-step__circle-container {
    margin-left: 20px;
  }

  // 最后一个步骤图标向左挪，对齐文字中心
  .van-step--horizontal:last-child .van-step__circle-container {
    margin-right: 20px;
  }

  @media screen and (min-width: 768px) {
    .van-step__title {
      font-size: 13px;
    }

    .step-icon {
      width: 24px;
      height: 24px;
      font-size: 12px;
    }

    .van-step__line {
      bottom: 22px !important;
    }
  }
}
</style>
